import { IntercomProvider } from "react-use-intercom";

const APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

export default function IntercomWrapper({ children }: { children: React.ReactNode }) {
  return (
    <IntercomProvider appId={APP_ID!} autoBoot>
      {children}
    </IntercomProvider>
  );
}
